import { createRequestInstance } from 'services'
import { AffiliateCompetitionRecord } from 'types/Affiliate'

export const VITE_COMPETITIONS_API_URL =
  import.meta.env.VITE_COMPETITIONS_API_URL || ''

const request = createRequestInstance({
  baseURL: VITE_COMPETITIONS_API_URL,
})

export type FetchAffiliateCompetitionsResponse = {
  affiliateId: number
  competitions: AffiliateCompetitionRecord[]
}

export async function fetchAffiliateCompetitions(
  affiliateId: number,
): Promise<FetchAffiliateCompetitionsResponse> {
  const response = await request.get<FetchAffiliateCompetitionsResponse>(
    `/affiliates/${affiliateId}/competitions`,
  )

  return response.data
}
